// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1zmjy","messages":"Chat_messages__-B81A","dateDivider":"Chat_dateDivider__aqORV"};